/**
 * 算法备案 · 合规配置(2026-10-11 设计 §1)。三端统一形状:
 * `{"visibleLabel":false,"lexiconFilter":false,"cloudModeration":false,"domesticOnly":false}`
 *
 * 解析在 api 侧做(租户行非 NULL 列 > `_global` 行 > 代码兜底);console 只在「字段缺失」(老后端 /
 * 权限还没拉到)时按代码兜底补齐 —— 四项默认全关(1011 拍板:不影响现有租户,备案租户在平台后台逐户打开)。
 */
export interface Compliance {
  visibleLabel: boolean;
  lexiconFilter: boolean;
  cloudModeration: boolean;
  domesticOnly: boolean;
}

export type ComplianceKey = keyof Compliance;

/** 平台写端点 body:true/false = 覆盖,null = 跟随全局(租户行)。 */
export type ComplianceOverride = Record<ComplianceKey, boolean | null>;

export const COMPLIANCE_KEYS: readonly ComplianceKey[] = [
  "visibleLabel",
  "lexiconFilter",
  "cloudModeration",
  "domesticOnly",
] as const;

/** 代码兜底(与 api / ai 一致):四项全 false(1011 拍板默认全关)。 */
export const DEFAULT_COMPLIANCE: Compliance = {
  visibleLabel: false,
  lexiconFilter: false,
  cloudModeration: false,
  domesticOnly: false,
};

/** 任意来源(可能缺字段 / null / 非布尔)→ 补齐成完整 Compliance;只认真布尔,其余落兜底。 */
export function resolveCompliance(
  raw: Partial<Record<ComplianceKey, unknown>> | null | undefined
): Compliance {
  const out = { ...DEFAULT_COMPLIANCE };
  if (!raw) return out;
  for (const k of COMPLIANCE_KEYS) {
    const v = raw[k];
    if (typeof v === "boolean") out[k] = v;
  }
  return out;
}

export const COMPLIANCE_LABELS: Record<ComplianceKey, { title: string; desc: string }> = {
  visibleLabel: {
    title: "可见「AI生成」标识",
    desc: "图片 / 视频左下角「AI生成」、音频开头提示语、文本回复下方「内容由AI生成」小字",
  },
  lexiconFilter: {
    title: "敏感词拦截",
    desc: "用户输入与文本输出命中敏感词库时拦截(提示「内容包含敏感信息,无法生成」)",
  },
  cloudModeration: {
    title: "云端内容安全(图 / 视频 / 音频)",
    desc: "阿里云内容安全机审。需开通内容安全并配置 AK,本期开关暂无实效",
  },
  domesticOnly: {
    title: "只用国内模型",
    desc: "出图 / 编排 / 深度构思等全部切国内模型;隐藏境外档位、境外 AI 可见度与真人出镜入口",
  },
};
